import VueI18n from 'vue-i18n'
import Vue from 'vue'
import moment from 'moment'
import { messages, datetime  } from './locales'
import cookie from 'js-cookie'

Vue.use(VueI18n)
window.moment = moment

const i18n = new VueI18n({
  locale: 'de',
  fallbackLocale: 'en',
  dateTimeFormats: datetime ,
  messages: messages,
  silentTranslationWarn: true
})

let language = cookie.get('language')
if (language !== undefined) {
  i18n.locale = language
  moment.locale(language)
} else {
  // default locale
  i18n.locale = 'de'
  moment.locale('de')
}
export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js